"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiTooltip = getMuiTooltip;
function getMuiTooltip() {
  return {
    styleOverrides: {
      arrow: function (_ref) {
        var ownerState = _ref.ownerState,
          theme = _ref.theme;
        return {
          '&::before': {
            border: (ownerState == null ? void 0 : ownerState.variant) === 'light' ? "1px solid ".concat(theme.palette.gray[200]) : 'unset'
          },
          color: (ownerState == null ? void 0 : ownerState.variant) === 'dark' ? theme.palette.gray[900] : theme.palette.common.white
        };
      },
      tooltip: function (_ref2) {
        var ownerState = _ref2.ownerState,
          theme = _ref2.theme;
        return {
          '.MuiTypography-root': {
            color: (ownerState == null ? void 0 : ownerState.variant) === 'dark' ? theme.palette.common.white : theme.palette.gray[500],
            fontWeight: 500
          },
          '.MuiTypography-root:first-child': {
            color: (ownerState == null ? void 0 : ownerState.variant) === 'dark' ? theme.palette.common.white : theme.palette.gray[700],
            fontWeight: 600
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'dark' ? theme.palette.gray[900] : theme.palette.common.white,
          border: (ownerState == null ? void 0 : ownerState.variant) === 'light' ? "1px solid ".concat(theme.palette.gray[200]) : 'unset',
          borderRadius: 8,
          boxShadow: '0px 4px 6px -2px rgba(18, 25, 38, 0.03), 0px 12px 16px -4px rgba(18, 25, 38, 0.08)',
          color: (ownerState == null ? void 0 : ownerState.variant) === 'dark' ? theme.palette.common.white : theme.palette.gray[500],
          maxWidth: 320
        };
      },
      tooltipArrow: function () {
        return {
          boxShadow: '0px 4px 6px -2px rgba(18, 25, 38, 0.03), 0px 12px 16px -4px rgba(18, 25, 38, 0.08)'
        };
      }
    }
  };
}